var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20 20h-4v-4h4zm-6-10h-4v4h4zm6 0h-4v4h4zM8 16H4v4h4zm6 0h-4v4h4zm-6-6H4v4h4zm16-8v22H0V2h3v1c0 1.103.897 2 2 2s2-.897 2-2V2h10v1c0 1.103.897 2 2 2s2-.897 2-2V2zm-2 6H2v14h20zm-2-7a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0zM6 3a1 1 0 1 1-2 0V1a1 1 0 1 1 2 0z"
})));
export { SvgCalendar as ReactComponent };
export default __webpack_public_path__ + "assets/images/calendar.svg";